import React from "react";
import { useNavigate } from "react-router-dom";
import { resolveEndpoint } from "../utils/utils";

export const Auth = () => {
  const navigate = useNavigate();
  const [token, setToken] = React.useState<string>("");
  const [apiMessage, setApiMessage] = React.useState<string>("");

  // get from local storage
  React.useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken) {
      setToken(storedToken);
    }
  }, []);

  const testToken = async () => {
    setApiMessage("Testing token...");

    try {
      const res = await fetch(`${resolveEndpoint()}/test`, {
        method: "GET",
        headers: { authorization: `Bearer ${token || localStorage.getItem("token") || ""}` },
      });

      if (!res.ok) {
        if (res.status === 401 || res.status === 403) {
          setApiMessage("Incorrect token. Please double-check and try again.");
        } else if (res.status >= 500) {
          setApiMessage("Server error. Please try again later.");
        } else {
          setApiMessage(`Something went wrong (HTTP ${res.status}). Please try again.`);
        }
        return;
      }

      localStorage.setItem("token", token);
      setApiMessage("success");
    } catch (e: any) {
      setApiMessage("Could not connect to the server. Check your connection and try again.");
    }
  };

  return (
    <div className="h-full w-full p-4">
      <h1>Auth</h1>
      <nav>
        <ul>
          <li>
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                navigate("/");
              }}
            >
              &gt; Main Layout
            </a>
          </li>

        </ul>
      </nav>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          testToken();
        }}
      >
        <div className="form-group">
          <label htmlFor="token">Token:</label>
          <input
            placeholder="Enter your token"
            type="text"
            id="token"
            value={token}
            onChange={(e) => setToken(e.target.value)}
          />
        </div>

        <button type="submit" className="btn btn-default">
          Set Token
        </button>
      </form>

      {apiMessage && (
        <div className="mt-4">
          {apiMessage === "success" ? (
            <p style={{ color: "black" }}>
              Success. Click on &quot;Main Layout&quot; above to continue.
            </p>
          ) : (
            <p style={{ color: "black" }}>{apiMessage}</p>
          )}
        </div>
      )}
    </div>
  );
};
